import { Mail } from "lucide-react";
import { PageHero, Reveal, Card, usePageMeta } from "@/components/primitives";
import EnquiryForm from "@/components/EnquiryForm";
import { SocialLinks } from "@/components/Footer";
import { CONTACT_EMAILS, INTERESTS } from "@/lib/data";

export default function Contact() {
  usePageMeta(
    "Contact | Avyagrah Tech Innovations",
    "Let's build the future together — contact Avyagrah Tech Innovations for partnerships, investment, banking integration, institutional, media and career enquiries."
  );
  return (
    <>
      <PageHero
        eyebrow="Contact"
        lines={["Let's Build the", "Future Together."]}
        lead="One form, straight to the founding team. Choose your interest and we'll route it properly."
      />

      <section className="py-24 sm:py-32" data-testid="contact-section">
        <div className="mx-auto grid max-w-[1440px] gap-12 px-6 lg:grid-cols-12 lg:px-8">
          <div className="lg:col-span-7">
            <EnquiryForm
              defaultInterest="General Enquiry"
              source="contact-page"
              heading="Submit an Enquiry"
              testid="contact-enquiry"
            />
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <Card testid="contact-info-card" className="p-8">
                <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-electric">Direct Line</p>
                <div className="mt-4 space-y-3">
                  {CONTACT_EMAILS.map((email, i) => (
                    <a
                      key={email}
                      href={`mailto:${email}`}
                      data-testid={`contact-email-link-${i + 1}`}
                      className="flex items-center gap-3 font-display text-base font-semibold text-mist transition-colors hover:text-electric"
                    >
                      <Mail className="h-5 w-5 shrink-0 text-teal" />
                      {email}
                    </a>
                  ))}
                </div>
                <p className="mt-6 text-sm leading-relaxed text-mute">
                  We typically respond within 2–3 business days. Every enquiry is read by the team —
                  not an automation.
                </p>
              </Card>
            </Reveal>
            <Reveal delay={0.18} className="mt-6">
              <Card testid="contact-social-card" className="p-8">
                <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-electric">Follow & Message</p>
                <div className="mt-5">
                  <SocialLinks />
                </div>
              </Card>
            </Reveal>
            <Reveal delay={0.26} className="mt-6">
              <Card testid="contact-interests-card" className="p-8">
                <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-electric">What You Can Reach Us About</p>
                <ul className="mt-5 space-y-3">
                  {INTERESTS.map((i) => (
                    <li key={i} className="flex items-center gap-3 text-sm text-mist/85">
                      <span className="h-1 w-1 rounded-full bg-teal" aria-hidden="true" />
                      {i}
                    </li>
                  ))}
                </ul>
              </Card>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
